import { SecondaryButton } from '@designsforhealth/dfh-react-components'
import React from 'react'

import { usePageUrl } from '../../../../../lib/pages'
import { TableDataOrder } from './types'

interface LinkToShipmentProps {
  orderId: TableDataOrder['orderId']
  urlFragment: string
}

export const LinkToShipment: React.VFC<LinkToShipmentProps> = ({ orderId, urlFragment }) => {
  const { navigate } = usePageUrl()
  return (
    <SecondaryButton
      text="Track"
      onClick={() => {
        navigate(`/account/${urlFragment}/${orderId}/shipments`)
      }}
    />
  )
}
